// extracted by mini-css-extract-plugin
module.exports = {"ComingSoonWrapper":"ComingSoon_ComingSoonWrapper__XMyFq"};